import { debug as _debug, label } from '../.debug.js';

export const debug = _debug.withSublabel(label, 'GlobalJs');
